<template>
  <div class="filter-search">
    <div class="container">
      <form class="filter-search-form" autocomplete="off">
        <div class="registration-sources-list" style="display: none">
          <label class="custom-check">
            <input type="checkbox" name="selectAll" @change="selectAllInputs" />
            <span class="checkmark"></span>
            <p>Select All</p>
          </label>
          <div class="sources-main">
            <div class="region">
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="southeastAsiaMain"
                  @change="southeastAsia"
                />
                <span class="checkmark"></span>
                <h5>Southeast Asia</h5>
              </label>
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="southeastAsia"
                  value="Singapore HSA"
                  v-model="filters.sources"
                />
                <span class="checkmark"></span>
                <p>Singapore</p>
              </label>
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="southeastAsia"
                  value="Malaysia Medical Device Authority"
                  v-model="filters.sources"
                />
                <span class="checkmark"></span>
                <p>Malaysia</p>
              </label>
              <label class="custom-check source-disabled">
                <input
                  type="checkbox"
                  name="southeastAsia"
                  value="Thailand FDA"
                  v-model="filters.sources"
                  disabled
                />
                <span class="checkmark"></span>
                <p>Thailand</p>
              </label>
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="southeastAsia"
                  value="Philippines FDA"
                  v-model="filters.sources"
                />
                <span class="checkmark"></span>
                <p>Philippines</p>
              </label>
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="southeastAsia"
                  value="Indonesia PRKT"
                  v-model="filters.sources"
                />
                <span class="checkmark"></span>
                <p>Indonesia</p>
              </label>
            </div>
            <div class="region">
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="southAsiaMain"
                  @change="southAsia"
                />
                <span class="checkmark"></span>
                <h5>South Asia</h5>
              </label>
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="southAsia"
                  value="VietNam Ministry of Health - Medical Disclosure Portal"
                  v-model="filters.sources"
                />
                <span class="checkmark"></span>
                <p>Vietnam</p>
              </label>
              <label class="custom-check source-disabled">
                <input
                  type="checkbox"
                  name="southAsia"
                  value="india"
                  v-model="filters.sources"
                  disabled
                />
                <span class="checkmark"></span>
                <p>India</p>
              </label>
              <label class="custom-check source-disabled">
                <input
                  type="checkbox"
                  name="southAsia"
                  value="bangladesh"
                  v-model="filters.sources"
                  disabled
                />
                <span class="checkmark"></span>
                <p>Bangladesh</p>
              </label>
            </div>
            <div class="region">
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="greaterChinaMain"
                  @change="greaterChina"
                />
                <span class="checkmark"></span>
                <h5>Greater China</h5>
              </label>
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="greaterChina"
                  value="China's NMPA - Imported Products"
                  v-model="filters.sources"
                />
                <span class="checkmark"></span>
                <p>China (Imported)</p>
              </label>
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="greaterChina"
                  value="Hong Kong MDD"
                  v-model="filters.sources"
                />
                <span class="checkmark"></span>
                <p>Hong Kong</p>
              </label>
              <label class="custom-check source-disabled">
                <input
                  type="checkbox"
                  name="greaterChina"
                  value="taiwan"
                  v-model="filters.sources"
                  disabled
                />
                <span class="checkmark"></span>
                <p>Taiwan</p>
              </label>
            </div>
            <div class="region">
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="asiaPacificMain"
                  @change="asiaPacific"
                />
                <span class="checkmark"></span>
                <h5>Asia Pacific</h5>
              </label>
              <label class="custom-check">
                <input
                  type="checkbox"
                  name="asiaPacific"
                  value="Australia ARTG"
                  v-model="filters.sources"
                />
                <span class="checkmark"></span>
                <p>Australia</p>
              </label>
              <label class="custom-check source-disabled">
                <input
                  type="checkbox"
                  name="asiaPacific"
                  value="newZealand"
                  v-model="filters.sources"
                  disabled
                />
                <span class="checkmark"></span>
                <p>New Zealand</p>
              </label>
            </div>
            <div class="region">
              <label class="custom-check source-disabled">
                <input
                  type="checkbox"
                  name="northAmericaMain"
                  @change="northAmerica"
                  disabled
                />
                <span class="checkmark"></span>
                <h5>North America</h5>
              </label>
              <label class="custom-check source-disabled">
                <input
                  type="checkbox"
                  name="northAmerica"
                  value="USFDA"
                  v-model="filters.sources"
                  disabled
                />
                <span class="checkmark"></span>
                <p>United States</p>
              </label>
              <label class="custom-check source-disabled">
                <input
                  type="checkbox"
                  name="northAmerica"
                  value="canada"
                  v-model="filters.sources"
                  disabled
                />
                <span class="checkmark"></span>
                <p>Canada</p>
              </label>
              <span class="coming-soon">Coming soon!</span>
            </div>
          </div>
        </div>
        <div class="title-span">
          <svg
            width="16"
            height="20"
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="!this.isUserPremium()"
          >
            <path
              d="M16 10C16 8.897 15.103 8 14 8H13V5C13 2.243 10.757 0 8 0C5.243 0 3 2.243 3 5V8H2C0.897 8 0 8.897 0 10V18C0 19.103 0.897 20 2 20H14C15.103 20 16 19.103 16 18V10ZM5 5C5 3.346 6.346 2 8 2C9.654 2 11 3.346 11 5V8H5V5Z"
              fill="#333333"
            />
          </svg>
          <h2>Product Search Fields</h2>
        </div>
        <div class="filter-options-wrap">
          <div class="option-wrap filter-input-mt" style="position: relative">
            <input
              type="text"
              v-model="filters.keywordQuery"
              placeholder="Keyword"
              id="product-name"
            />
            <div @click="isFilterLocked">
              <!-- v-on:keyup='showManufacturerSuggestions' -->
              <input
                type="text"
                id="manufacturer-name"
                v-model="filters.manufacturerName"
                placeholder="Manufacturer Name"
                :disabled="!this.isUserPremium()"
              />
            </div>
            <div class="manufacturer-suggestions">
              <p
                @click="selectManufacturerSuggestion"
                v-for="suggestion in productManufacturerSuggestion"
                :key="suggestion"
              >
                {{ suggestion }}
              </p>
            </div>
          </div>
          <div class="option-wrap country-only" hidden>
            <p>(In Development)</p>
            <div @click="isFilterLocked">
              <!-- :disabled='!this.isUserPremium()' -->
              <input
                type="text"
                v-model="filters.productCategory"
                placeholder="Product Category"
                id="product-category"
                v-on:keyup="showCategorySuggestions"
                :disabled="true"
              />
            </div>
            <div class="category-suggestions">
              <p
                @click="selectCategorySuggestion"
                v-for="suggestion in productCategorySuggestion"
                :key="suggestion"
              >
                {{ suggestion }}
              </p>
            </div>
            <div @click="isFilterLocked">
              <input
                type="text"
                v-model="filters.exclude"
                placeholder="Exclude"
                :disabled="!this.isUserPremium()"
              />
            </div>
          </div>
          <div class="option-wrap country-only" hidden>
            <p>(In Development)</p>
            <div @click="isFilterLocked">
              <select
                :disabled="!this.isUserPremium()"
                v-model="filters.specialty"
                id="speciality-select"
              >
                <option selected :value="null">Medical Speciality</option>
                <option
                  v-for="(item, index) in deviceSpecialties"
                  :key="index"
                  :value="item[1]"
                >
                  {{ item[1] }}
                </option>
              </select>
            </div>
            <div @click="isFilterLocked">
              <select
                v-model="filters.riskLevel"
                id="risk-level-select"
                :disabled="!this.isUserPremium()"
                placeholder="None"
              >
                <option selected :value="null">Risk Level</option>
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
              </select>
            </div>
          </div>
          <div class="option-wrap filter-button-mt">
            <button
              type="button"
              style="font-size: 20px"
              class="sources"
              @click="registrationSources"
              :disabled="false"
            >
              Select Countries
              <svg
                width="9"
                height="12"
                viewBox="0 0 9 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 6L-4.89399e-07 11.1961L-3.51373e-08 0.803847L9 6Z"
                  fill="#676868"
                />
              </svg>
            </button>
          </div>
          <div class="option-wrap filter-button-mt">
            <button
              style="font-size: 20px"
              class="orange-btn"
              :disabled="false"
              @click.prevent="applyFilters"
            >
              Search
            </button>
          </div>
          <button
            type="button"
            class="save-search-btn"
            @click="displaySaveModal"
            :disabled="false"
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.6667 21C19.2855 21 19.879 20.7542 20.3166 20.3166C20.7542 19.879 21 19.2855 21 18.6667V2.33333C21 1.71449 20.7542 1.121 20.3166 0.683417C19.879 0.245833 19.2855 0 18.6667 0H2.33333C1.71449 0 1.121 0.245833 0.683417 0.683417C0.245833 1.121 0 1.71449 0 2.33333V18.6667C0 19.2855 0.245833 19.879 0.683417 20.3166C1.121 20.7542 1.71449 21 2.33333 21H18.6667ZM9.33333 10.5V4.66667H11.6667V10.5H16.3333L10.5 16.3333L4.66667 10.5H9.33333Z"
                fill="#858585"
              />
            </svg>
            Save Search
          </button>
        </div>
      </form>
    </div>
    <SaveModal
      @click="closeModal"
      :filters="filters"
      @save="saveSearchFields"
    />
    <Locked-modal />
  </div>
</template>

<script>
// @ is an alias to /src
import SaveModal from "@/components/user/modals/save.vue";
import LockedModal from "@/components/user/modals/locked.vue";
import LoadAnimation from "@/components/global/loadAnimation.vue";

import { axiosClient } from "@/axios-client";

const DEVICE_SPECIALTIES = [
  ["AN", "Anesthesiology"],
  ["CV", "Cardiovascular"],
  ["CH", "Clinical Chemistry"],
  ["DE", "Dental"],
  ["EN", "Ear, Nose, & Throat"],
  ["GU", "Gastroenterology & Urology"],
  ["OR", "Orthopedic"],
  ["HO", "General Hospital"],
  ["HE", "Hematology"],
  ["IM", "Immunology"],
  ["MI", "Microbiology"],
  ["NE", "Neurology"],
  ["OB", "Obstetrics/Gynecology"],
  ["OP", "Ophthalmic"],
  ["TX", "Clinical Toxicology"],
  ["PA", "Pathology"],
  ["PM", "Physical Medicine"],
  ["RA", "Radiology"],
  ["SU", "General & Plastic Surgery"],
];

export default {
  props: ["keyword", "searchResultsNum", "filters"],
  data() {
    return {
      counters: {
        basic: 0,
        southeastAsia: false,
        southAsia: false,
        greaterChina: false,
        asiaPacific: false,
        northAmerica: false,
      },

      // filters: {
      //   productName: null,
      //   manufacturerName: null,
      //   productCategory: null,
      //   exclude: null,
      //   specialty: null,
      //   riskLevel: null,
      //   sources: []
      // },

      deviceSpecialties: [
        ["AN", "Anesthesiology"],
        ["CV", "Cardiovascular"],
        ["CH", "Clinical Chemistry"],
        ["DE", "Dental"],
        ["EN", "Ear, Nose, & Throat"],
        ["GU", "Gastroenterology & Urology"],
        ["OR", "Orthopedic"],
        ["HO", "General Hospital"],
        ["HE", "Hematology"],
        ["IM", "Immunology"],
        ["MI", "Microbiology"],
        ["NE", "Neurology"],
        ["OB", "Obstetrics/Gynecology"],
        ["OP", "Ophthalmic"],
        ["TX", "Clinical Toxicology"],
        ["PA", "Pathology"],
        ["PM", "Physical Medicine"],
        ["RA", "Radiology"],
        ["SU", "General & Plastic Surgery"],
      ],

      currentUser: null,

      productCategorySuggestion: [],
      productManufacturerSuggestion: [],
    };
  },

  mounted() {
    axiosClient.get("v1/account").then((response) => {
      this.currentUser = response.data;
    });

    let inputs = document.querySelectorAll(".registration-sources-list input");
    inputs.forEach((el) => {
      if (el.getAttribute("disabled") == null) el.checked = true;
      if (el.value != "on" && el.getAttribute("disabled") == null)
        this.filters.sources.push(el.value);
      if (el.getAttribute("disabled") == null) {
        el.checked = true;
      }
    });
  },

  updated() {
    let inputs = document.querySelectorAll(
      ".registration-sources-list input:checked"
    );
    let sourcesBtn = document.querySelector(".option-wrap .sources");

    if (inputs.length) {
      sourcesBtn.classList.add("active-sources-btn");
    } else {
      sourcesBtn.classList.remove("active-sources-btn");
    }
  },

  components: {
    SaveModal,
    LockedModal,
    LoadAnimation,
  },

  methods: {
    removeItemsFromArray(array) {
      let arr = Object.values(array);
      let emptyArray = [];

      arr.forEach((el) => {
        emptyArray.push(el.value);
      });

      this.filters.sources = this.filters.sources.filter(
        (item) => !idk.includes(item)
      );
    },
    showCategorySuggestions(e) {
      let value = e.target.value;
      let length = e.target.value.length;
      let suggestions = document.querySelector(".category-suggestions");

      axiosClient
        .get(
          "v1/search/registrations/product-categories/autocomplete?query=" +
            value
        )
        .then((response) => {
          this.productCategorySuggestion = [];
          response.data.suggestions.forEach((el) => {
            this.productCategorySuggestion.push(el);
          });
        })
        .catch((err) => console.log(err));

      if (length >= 3 && this.productCategorySuggestion != 0) {
        suggestions.style.display = "block";
      } else {
        suggestions.style.display = "none";
      }
    },

    // showManufacturerSuggestions(e) {
    //   let value = e.target.value;
    //   let length = e.target.value.length;
    //   let suggestions = document.querySelector('.manufacturer-suggestions');

    //   axiosClient.get('v1/search/registrations/parent-companies/autocomplete?query=' + value)
    //     .then((response) => {
    //       this.productManufacturerSuggestion = [];
    //       response.data.suggestions.forEach(el => {
    //         this.productManufacturerSuggestion.push(el);
    //       })
    //     })
    //     .catch((err) => console.log(err));

    //   if(length >= 3 && this.productManufacturerSuggestion.length != 0) {
    //     suggestions.style.display = 'block';
    //   } else {
    //     suggestions.style.display = 'none';
    //   }
    // },

    isFilterLocked() {
      if (!this.isUserPremium()) {
        document.querySelector(".search-result-detail").style.display = "none";
        document.querySelector(".locked-modal").style.opacity = "1";
        document.querySelector(".locked-modal").style.zIndex = "999";
        document.querySelector(".locked-modal").classList.add("isModalOpen");
        document.querySelector("body").style.overflow = "hidden";
      }
    },

    applyFilters() {
      this.$emit("filters", this.filters);
      this.$store.commit("resultsAreLoading");
      document.querySelector(".manufacturer-suggestions").style.display =
        "none";
      document.querySelector(".category-suggestions").style.display = "none";
      axiosClient
        .post("v1/search/registrations", {
          keywordQuery: this.filters.keywordQuery,
          //  productName: this.filters.productName,
          productCategory: this.filters.productCategory,
          manufacturerName: this.filters.manufacturerName,
          specialty: this.filters.specialty,
          riskLevel: this.filters.riskLevel,
          exclude: this.filters.exclude,
          sources: this.filters.sources,
        })
        .then((response) => {
          const registrations = response.data.records || response.data;
          this.$emit("searched", registrations);
          this.$store.commit("resultsLoaded");
        })
        .catch((err) => console.log(err));
    },

    selectCategorySuggestion(e) {
      let value = e.target.innerHTML.trim().replace("&amp;", "&");
      let suggestions = document.querySelector(".category-suggestions");
      document.querySelector("#product-category").value = value;
      this.filters.productCategory = value;
      suggestions.style.display = "none";
    },

    selectManufacturerSuggestion(e) {
      let value = e.target.innerHTML.trim().replace("&amp;", "&");
      let suggestions = document.querySelector(".manufacturer-suggestions");
      document.querySelector("#manufacturer-name").value = value;
      this.filters.manufacturerName = value;
      suggestions.style.display = "none";
    },

    registrationSources(e) {
      let target = e.target.className;
      let sources = document.querySelector(".registration-sources-list");

      if (sources.style.display == "none") {
        sources.style.display = "block";
      } else {
        sources.style.display = "none";
      }
    },

    selectAllInputs() {
      let inputs = document.querySelectorAll(
        ".registration-sources-list input"
      );
      this.counters.basic++;
      this.counters.southeastAsia = false;
      this.counters.southAsia = false;
      this.counters.greaterChina = false;
      this.counters.asiaPacific = false;
      this.counters.northAmerica = false;

      for (let input of inputs) {
        if (this.counters.basic % 2 == 0) {
          if (input.value != "on" && input.getAttribute("disabled") == null)
            this.filters.sources.push(input.value);
          if (input.getAttribute("disabled") == null) {
            input.checked = true;
          }
        } else {
          input.checked = false;
          this.filters.sources = [];
          this.counters.southeastAsia = true;
          this.counters.southAsia = true;
          this.counters.greaterChina = true;
          this.counters.asiaPacific = true;
          this.counters.northAmerica = true;
        }
      }

      if (this.counters.basic >= 2) {
        this.counters.basic = 0;
      }
    },

    southeastAsia() {
      let southeastAsiaCheckboxes = document.getElementsByName("southeastAsia");

      if (this.counters.southeastAsia) {
        this.counters.southeastAsia = false;
        southeastAsiaCheckboxes.forEach((el) => {
          if (el.getAttribute("disabled") == null) {
            el.checked = false;
            this.filters.sources.push(el.value);
          }
        });
      } else {
        this.counters.southeastAsia = true;
        this.removeItemsFromArray(southeastAsiaCheckboxes);
        southeastAsiaCheckboxes.forEach((el) => {
          if (el.getAttribute("disabled") == null) {
            el.checked = false;
            // this.filters.sources.pop();
          }
        });
      }
    },

    southAsia() {
      let southAsiaCheckboxes = document.getElementsByName("southAsia");

      if (!this.counters.southAsia) {
        this.counters.southAsia = true;
        southAsiaCheckboxes.forEach((el) => {
          el.checked = true;
          this.filters.sources.push(el.value);
        });
      } else {
        this.counters.southAsia = false;
        southAsiaCheckboxes.forEach((el) => {
          el.checked = false;
          this.filters.sources.pop();
        });
      }
    },

    greaterChina() {
      let greaterChinaCheckboxes = document.getElementsByName("greaterChina");

      if (this.counters.greaterChina) {
        this.counters.greaterChina = false;
        greaterChinaCheckboxes.forEach((el) => {
          if (el.getAttribute("disabled") == null) {
            if (el.getAttribute("disabled") == null) {
              el.checked = false;
              this.filters.sources.push(el.value);
            }
          }
        });
      } else {
        this.counters.greaterChina = true;
        this.removeItemsFromArray(greaterChinaCheckboxes);
        greaterChinaCheckboxes.forEach((el) => {
          if (el.getAttribute("disabled") == null) {
            el.checked = false;
            // this.filters.sources.pop();
          }
        });
      }
    },

    asiaPacific() {
      let asiaPacificCheckboxes = document.getElementsByName("asiaPacific");

      if (!this.counters.asiaPacific) {
        this.counters.asiaPacific = true;
        asiaPacificCheckboxes.forEach((el) => {
          if(el.getAttribute("disabled") == null){
            el.checked = true;
            this.filters.sources.push(el.value);
          }
        });
      } else {
        this.counters.asiaPacific = false;
        asiaPacificCheckboxes.forEach((el) => {
          if(el.getAttribute("disabled") == null){
            el.checked = false;
            this.filters.sources.pop();
          }
        });
      }
    },

    northAmerica() {
      let northAmericaCheckboxes = document.getElementsByName("northAmerica");

      if (this.counters.northAmerica) {
        this.counters.northAmerica = false;
        northAmericaCheckboxes.forEach((el) => {
          if (el.getAttribute("disabled") == null) {
            el.checked = false;
            this.filters.sources.push(el.value);
          }
        });
      } else {
        this.counters.northAmerica = true;
        this.removeItemsFromArray(northAmericaCheckboxes);
        northAmericaCheckboxes.forEach((el) => {
          if (el.getAttribute("disabled") == null) {
            el.checked = false;
            // this.filters.sources.pop();
          }
        });
      }
    },

    displaySaveModal() {
      document.querySelector(".search-result-detail").style.display = "none";
      document.querySelector(".save-modal-wrapper").style.opacity = "1";
      document.querySelector(".save-modal-wrapper").style.zIndex = "999";
      document
        .querySelector(".save-modal-wrapper")
        .classList.add("isModalOpen");
      document.querySelector("body").style.overflow = "hidden";
    },

    closeModal(e) {
      document.querySelector(".save-modal-wrapper").style.opacity = "0";
      document.querySelector(".save-modal-wrapper").style.zIndex = "-999";
      document
        .querySelector(".save-modal-wrapper")
        .classList.remove("isModalOpen");
      document.querySelector("body").style.overflow = "auto";
    },

    saveSearchFields(searchName) {
      axiosClient
        .post("v1/search/registrations/saved-searches", {
          keywordQuery: this.filters.keywordQuery,
          productName: this.filters.productName,
          productCategory: this.filters.productCategory,
          manufacturerName: this.filters.manufacturerName,
          specialty: this.filters.specialty,
          riskLevel: this.filters.riskLevel,
          sources: this.filters.sources,
          exclude: this.filters.exclude,
          resultsCount: this.searchResultsNum,
          dateLastSearched: this.formatTodaysDate(),
          listingName: searchName,
        })
        .catch((err) => console.log(err));
    },

    isUserPremium() {
      // return this.currentUser.tier == 'FREE' ? 0 : 1;
      // if(this.currentUser.tier == 'FREE') {
      //   return 0;
      // } else {
      //   return 1;
      // }
      // TODO: Unlocking for now for easier user testing.
      return 1;
    },

    formatTodaysDate() {
      let date = new Date();
      let d = date.getDate();
      let m = date.getMonth() + 1;
      let y = date.getFullYear();
      return `${y}-${m}-${d}`;
    },
  },
};
</script>

<style lang="scss">
.filter-search {
  .container {
    form.filter-search-form {
      background: #fff;
      padding: 30px 50px;
      box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
      border-radius: 15px;
      position: relative;

      .registration-sources-list {
        background: #fff;
        border: 1px solid #cdcdcd;
        box-shadow: 0px 8px 20px rgba(51, 51, 51, 0.08);
        border-radius: 15px;
        padding: 40px 40px 10px 40px;
        width: 990px;
        position: absolute;
        z-index: 9999;
        top: 140px;
        left: 50%;
        transform: translate(-50%, 0);
        display: none;

        .custom-check {
          p,
          h5 {
            margin-left: 35px;
          }

          .checkmark {
            top: 4px;
          }

          &.source-disabled {
            p,
            h5 {
              color: #858585;
            }
          }
        }

        .sources-main {
          display: flex;
          justify-content: space-between;

          .region {
            position: relative;

            label:first-child {
              margin-bottom: 30px;
            }

            span.coming-soon {
              position: absolute;
              left: 0;
              top: -30px;
              font-size: 13px;
              color: #fcaf05;
            }
          }
        }
      }

      .title-span {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        svg {
          margin-right: 12px;
        }

        h2 {
          margin: 0;
          font-size: 20px;
          line-height: 17px;
        }
      }

      .filter-options-wrap {
        display: flex;
        justify-content: space-between;

        .option-wrap {
          display: flex;
          flex-direction: column;
          width: 21%;
          &.filter-input-mt {
            width: 50% !important;
            padding-right: 30px;
          }
          &.filter-button-mt {
            .sources.active-sources-btn,
            .orange-btn {
              height: 100% !important;
              margin-right: 30px;
              font-family: unset;
            }
          }
          .manufacturer-suggestions {
            position: absolute;
            top: 125px;
            left: 0;
            width: 275px;
            max-height: 270px;
            background: #fff;
            border-radius: 15px;
            box-shadow: 0px 8px 20px rgba(51, 51, 51, 0.08);
            border: 1px solid #cdcdcd;
            display: none;
            z-index: 999;
            padding: 25px 0;
            overflow: scroll;

            p {
              margin: 0;
              width: 100%;
              padding: 9px 40px;
              cursor: pointer;

              &:hover {
                color: #fcaf05;
                font-family: "Gotham-Medium";
              }
            }
          }

          &.category-wrap {
            position: relative;

            .category-suggestions {
              position: absolute;
              top: 75px;
              left: 0;
              width: 275px;
              max-height: 270px;
              background: #fff;
              border-radius: 15px;
              box-shadow: 0px 8px 20px rgba(51, 51, 51, 0.08);
              border: 1px solid #cdcdcd;
              display: none;
              z-index: 999;
              padding: 25px 0;
              overflow: scroll;

              p {
                margin: 0;
                width: 100%;
                padding: 9px 40px;
                cursor: pointer;

                &:hover {
                  color: #fcaf05;
                  font-family: "Gotham-Medium";
                }
              }
            }
          }

          &.country-only {
            position: relative;

            p {
              position: absolute;
              top: -9px;
              font-size: 14px;
              line-height: 13px;
              color: #676868;
              margin: 0;
            }
          }

          input,
          select {
            border: 1px solid #cdcdcd;
            border-radius: 5px;
            padding: 11px 20px;
            margin-top: 15px;
            color: #333;
            background: #fff;
            width: 100%;

            &:disabled {
              background: #f9f9f9;
            }

            &::placeholder {
              color: #676868;
              font-style: italic;
            }

            &:focus {
              outline: none;

              &::placeholder {
                color: #fff;
              }
            }
          }

          select {
            margin-top: 15px;
            -webkit-appearance: none;
            appearance: none;
            height: 48px;
            color: #676868;
            background: url("~/assets/images/common/Polygon 3 (1).svg") repeat-x;

            &:disabled {
              background: #f9f9f9;
            }
          }

          button {
            margin-top: 15px;
            height: 48px;
            border: none;

            &:focus {
              outline: none;
            }

            &.sources {
              color: #676868;
              background: #ebebeb;
              border-radius: 5px;

              &.active-sources-btn {
                background: #fcaf05;
                color: #fff;

                svg path {
                  fill: #fff;
                }
              }

              &:focus {
                outline: none;
              }

              svg {
                margin-left: 12px;
              }
            }
          }
        }

        button.save-search-btn {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 15px;
          background: #f9f9f9;
          border: 1px solid #e2e2e2;
          border-radius: 5px;
          width: 10%;
          color: #676868;

          &:focus {
            outline: none;
          }

          svg {
            margin-bottom: 14px;
          }

          &:hover {
            background: #fcaf05;
            color: #fff;

            svg {
              path {
                fill: #fff;
              }
            }
          }
        }
      }
    }
  }
}
</style>